import { preFormat, postFormat } from './file-with-type'
//------------------------------------------------
// Image field formatter
//------------------------------------------------
export default {
  type: 'File',
  preFormat: (fieldValues, Type) => {
    return preFormat(fieldValues, Type, 'File')
  },
  postFormat: (fieldValues, Type) => {
    return postFormat(fieldValues, Type, 'File')
  },
}
